import '../App.css';

function Info() {
  return (
    <div className="main">
      <h2>Info</h2>
      <div></div>
    </div>
  );
};

export default Info;
